<template>
	<div id="app" scroll="no">
		<keep-alive exclude="Market,marketCommission,marketMy,marketApply,ExamStart,marketStudy">
			<router-view></router-view>
		</keep-alive>
	</div>
</template>

<script>
import VConsole from 'vconsole';
import userStore from '@/store/user';
import { mapState } from 'pinia';
import { MP } from './map';
export default {
	name: 'App',
	data() {
		return {
			showLogo: true,
			ak: 'BHPi73CKP0GTBLntVa01Yb3H9kcd1R2X'
		};
	},
	computed: {
		...mapState(userStore, ['userInfo'])
	},
	async mounted() {
		await MP(this.ak);
		//为pc则用iframe把移动端页面显示到页面中间
		let userAgentInfo = window.navigator.userAgent;
		let Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
		//pc
		if (
			!Agents.some((item) => userAgentInfo.toLowerCase().includes(item.toLowerCase())) &&
			!(self.frameElement && self.frameElement.tagName == 'IFRAME')
		) {
			// 检查页面是否已经有iframe   这个判断让页面拥有只保留一个iframe
			let ifrTag = document.getElementsByTagName('iframe')[0];
			if (ifrTag) {
				// 如果有，则删除它
				ifrTag.remove();
			} else {
				let ifrTag = document.createElement('iframe');
				document.body.innerHTML = '';
				ifrTag.setAttribute('src', window.location.href);
				let styleObj = {
					width: '480px',
					height: '920px',
					position: 'absolute',
					left: '50%',
					transform: 'translateX(-50%)'
				};
				Object.entries(styleObj).forEach(([key, value]) => {
					ifrTag.style[key] = value;
				});
				document.body.append(ifrTag);
			}
		}
	},
	// o6wx85uU5A1KmiswAeuCZ7NOrxxo 客户-赵盟-赵盟
	// o6wx85maxpx6Y1TO93xPlUzC2BrQ  医生-何医生-赵盟
	created() {
		// new VConsole({ theme: 'dark' });
		// if (this.userInfo.customerId == 469||this.userInfo.customerId == 411 ||this.userInfo.customerId == 14772||this.userInfo.sessionId === 'o6wx85vTmzrmt4NyZufBkM550Xrs' || this.userInfo.sessionId === 'o6wx85h9Ftz2doDyEesMIiMleQpA'|| this.userInfo.sessionId === 'o6wx85hDNx0FEm44aJsytaSH62rE'|| this.userInfo.sessionId === 'o6wx85lhhQlSaqGFuD6_x94X8KBU') {
		//         new VConsole({ theme: 'dark' });
		// }
	},
	methods: {}
};
</script>

<style>
#app {
	overflow-x: hidden;
}

:-webkit-scrollbar {
	height: 0 !important;
	width: 0 !important;
	color: transparent !important;
	display: none !important;
}

::-webkit-scrollbar {
	height: 0 !important;
	width: 0 !important;
	color: transparent !important;
	display: none !important;
}

router-view:-webkit-scrollbar {
	height: 0 !important;
	width: 0 !important;
	color: transparent !important;
	display: none !important;
}

router-view::-webkit-scrollbar {
	height: 0 !important;
	width: 0 !important;
	color: transparent !important;
	display: none !important;
}

.icon0 {
	opacity: 0.5;
}
</style>
